"use strict";
// This requires the embedded page to have included a postMessage handler, that passes down the needed variables,
// check the example below:
//
// someFuncToGetYouWhatYouDesire() {
//   // Your code..
//   window.parent.postMessage({
//    'variablePassedDownToParentPage': someVarFromYourCodeThatPassesTheValue,
//    }, '*'); // Wildcard in the target may be replaced w/ the embedding domain
//   }
// }
const externalMediaContentElements = Array.from(document.querySelectorAll('.frame-type-gs1_iframe'));
if (externalMediaContentElements) {
    externalMediaContentElements.forEach((externalMediaContentElement) => {
        const iframe = externalMediaContentElement.querySelector('iframe');
        if (iframe.height === '100%') {
            window.addEventListener('message', function (event) {
                // SH: If you should pass more variables to the parent page in the future,
                // make sure to add them to the `types PostMessage` object located at `src/types/postMessage.d.ts`,
                // with the correct type that is passed down from the page of course. ;)
                if (event.data && typeof event.data.iframeHeight !== 'undefined') {
                    iframe.height = event.data.iframeHeight + 32 + 'px';
                }
            });
        }
    });
}
